module.exports = __webpack_public_path__ + "static/media/icon_valid.e4f762fb.svg";